<template>
  <div class="clientFundUseList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="
              $t.clientFund.serialRegistrationNumber +
              ' / ' +
              $t.clientFund.creditRefNo +
              ' / ' +
              $t.clientFund.exchangeNo
            "
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.clientFund.fundType }}：
          <span v-if="item.FundType == 1">{{ $t.clientFund.fdType1 }}</span>
          <span v-if="item.FundType == 2">{{ $t.clientFund.fdType2 }}</span>
          <span v-if="item.FundType == 3">{{ $t.clientFund.fdType3 }}</span>
          <span v-if="item.FundType == 4">{{ $t.clientFund.fdType4 }}</span>
          <span v-if="item.FundType == 5">{{ $t.clientFund.fdType5 }}</span>
        </div>
        <div class="list-item">
          {{ $t.clientFund.serialRegistrationNumber }} / {{ $t.clientFund.creditRefNo }} /
          {{ $t.clientFund.exchangeNo }}：{{ item.SystemOperationNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.operateDate }}：{{ item.CreateTime }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.remitterName }}：{{ item.RemitterName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.bookCurrency }}：{{ item.CurrencySn }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.bookAmount }}：{{ item.BookkeepingAmount }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.originBalance }}：{{ item.OriginalAccountBalance }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.bookBalance }}：{{ item.BookkeepingAccountBalance }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.fundClass }}：
          <span v-if="item.PaymentType == 1">{{ $t.clientFund.paymentType1 }}</span>
          <span v-if="item.PaymentType == 2">{{ $t.clientFund.paymentType2 }}</span>
        </div>
        <div class="list-item">{{ $t.clientFund.username }}：{{ item.UserName }}</div>
        <div class="list-item">{{ $t.clientFund.writeOff3 }}：{{ item.Remark }}</div>
        <div class="list-item">
          {{ $t.clientFund.applicant }}：{{ item.RequesterUserName }}
        </div>
        <div class="buttons" v-if="item.FundType != 5">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item)"
          >
            <span v-if="item.FundType == 1">{{ $t.clientFund.useButton1 }}</span>
            <span v-if="item.FundType == 2">{{ $t.clientFund.useButton2 }}</span>
            <span v-if="item.FundType == 3 || item.FundType == 4">{{
              $t.clientFund.useButton3
            }}</span>
          </van-button>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.clientFund.fundType }}</div>
        <van-radio-group v-model="fundType" direction="horizontal">
          <van-radio :name="1">{{ $t.clientFund.fdType1 }}</van-radio>
          <van-radio :name="2">{{ $t.clientFund.fdType2 }}</van-radio>
          <van-radio :name="3">{{ $t.clientFund.fdType3 }}</van-radio>
          <van-radio :name="4">{{ $t.clientFund.fdType4 }}</van-radio>
          <van-radio :name="5">{{ $t.clientFund.fdType5 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.currency }}</div>
        <van-radio-group v-model="currency" direction="horizontal">
          <van-radio
            :name="currency.SCId"
            v-for="(currency, index) in currencyList"
            :key="index"
            >{{ currency.CurrencySn }}</van-radio
          >
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>
        <div class="tool-bar-total">
          <div class="tool-bar-total-left">
            {{ $t.clientFund.beforeBlance }}
          </div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in currencyList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.AmountBalance }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">
            {{ $t.clientFund.frozenBalance }}
          </div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in currencyList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.FrozenAmount }}</div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button type="info" block @click="showStatistics = true">{{
          $t.meta.showStatistics
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "clientFundUseList",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      CustomerId: "",
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      currencyList: [],
      showStatistics: false,
      //filter
      searchText: "",
      currency: null,
      fundType: null,
      showFilter: false,
    };
  },
  created() {
    const { CustomerId } = this.$route.query;
    this.CustomerId = CustomerId;
    this.getCurrencyList();
  },
  methods: {
    gotoDetail(item) {
      if (item.FundType == 1) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "accountStatementsDetail",
          name: "accountStatementsDetail",
          query: [
            {
              name: "CTId",
              value: item.CTId,
            },
          ],
        });
      }
      if (item.FundType == 2) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "creditedDetails",
          name: "creditedDetails",
          query: [
            {
              name: "NuclearAccountNo",
              value: item.SystemOperationNumber,
            },
          ],
        });
      }
      if (item.FundType == 3 || item.FundType == 4) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "clientFundExchange",
          name: "clientFundExchange",
          query: [
            {
              name: "CFEId",
              value: item.CFEId,
            },
          ],
        });
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.currency || this.fundType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.currency = null;
      this.fundType = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CustomerId: this.CustomerId,
        FundType: this.fundType,
        SCId: this.currency,
      };
      this.$api.financialManagement
        .getCustomerFundUseDetailList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        var param = {
          CustomerId: this.CustomerId,
        };
        this.$api.financialManagement
          .getCustomerAvailableFundListByCustomerId(param)
          .then((res) => {
            this.currencyList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.clientFundUseList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
